import { Icon, IconProps } from '@chakra-ui/react'

export function KeyIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 30" fill="none" {...props}>
      <path
        d="M15.2079 2.63329C13.6663 1.07776 11.6083 0.145528 9.4261 0.0156703C7.24256 -0.114184 5.0889 0.566523 3.37425 1.92658C1.65958 3.288 0.505106 5.23446 0.131646 7.39557C-0.243175 9.55527 0.188892 11.7791 1.34474 13.641C2.50057 15.5014 4.29976 16.871 6.39864 17.4874C8.49631 18.1025 10.7481 17.9221 12.7216 16.9803L25.7043 30L29.8914 25.8009L32 23.6726L27.7978 19.4585L25.7043 21.558L23.6107 19.4585L25.7043 17.3589L21.5021 13.1448L19.4085 15.2443L16.9224 12.7511H16.9237C17.7129 11.0931 17.9719 9.23121 17.6652 7.42034C17.3585 5.60783 16.5 3.93606 15.2079 2.63329ZM6.81994 6.8324C7.66093 6.02456 8.90124 5.79903 9.9726 6.25695C11.0426 6.71622 11.7377 7.77146 11.7377 8.93881C11.7377 10.1062 11.0426 11.1614 9.9726 11.6207C8.90127 12.0786 7.66093 11.853 6.81994 11.0452C6.24612 10.4957 5.92172 9.73437 5.92172 8.93885C5.92172 8.14332 6.24612 7.38189 6.81994 6.8324Z"
        fill="currentColor"
      />
    </Icon>
  )
}
